import { useAuth } from "@clerk/react"
import { MimirClient } from "@mimir/api-client"
import { MimirClientProvider } from "@mimir/api-client"
import { useMemo, type ReactNode } from "react"

export function MimirProvider({ children }: { children: ReactNode }) {
  const { getToken } = useAuth()

  const client = useMemo(
    () =>
      new MimirClient({
        baseUrl: import.meta.env.VITE_API_BASE_URL,
        getToken: () => getToken(),
      }),
    [getToken],
  )

  return <MimirClientProvider client={client}>{children}</MimirClientProvider>
}
